import CustomerAttributeDomain, {
  AttributeValueType,
} from "./contact-attribute-domain";
import CustomerAddressDomain from "./customer-address-domain";

export default class ContactDomain {
  id?: number;

  groupId?: string;

  name: string;

  surname: string;

  address: CustomerAddressDomain | undefined;

  title: string | null;

  salutation: string | null;

  fullName: string;

  type: string;

  tagIds: string[];

  notes: string;

  isArchived: boolean;

  isKeyloop: boolean;

  isBlocked: boolean;

  attributes: CustomerAttributeDomain<AttributeValueType>[] = [];

  getAlphabeticalKey(): string {
    if (!this.name) {
      return "#";
    }

    const nameToSplit = this.name
      ? this.name.toUpperCase().trim()
      : this.surname.toUpperCase().trim();
    const firstLetter = nameToSplit.charAt(0);

    if (!/[A-Z]/.test(firstLetter)) {
      return "#";
    }

    return firstLetter;
  }

  getDisplayName(): string {
    if (this.fullName) {
      return this.fullName;
    }

    if (this.name || this.surname) {
      return `${this.name || ""} ${this.surname || ""}`;
    }

    return "";
  }

  getLatestAttributeWithAttributeId(
    attributeId: string
  ): CustomerAttributeDomain<AttributeValueType> | undefined {
    const allAttributesWithMatchingAttributeId = this.attributes.filter(
      (attr) => attr.attributeId === attributeId
    );

    if (allAttributesWithMatchingAttributeId.length === 0) {
      return undefined;
    }

    const latestAttributeWithMatchingAttributeId =
      allAttributesWithMatchingAttributeId.sort((a, b) => {
        return (
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        );
      });

    return latestAttributeWithMatchingAttributeId[0];
  }

  constructor(
    id: number | undefined,
    groupId: string | undefined,
    name: string,
    surname: string,
    address: CustomerAddressDomain | undefined,
    fullName: string,
    type: string,
    tagIds: string[],
    notes: string,
    isArchived: boolean,
    attributes: CustomerAttributeDomain<AttributeValueType>[] = [],
    title: string | null = null,
    salutation: string | null = null,
    isKeyloop: boolean = false,
    isBlocked: boolean = false
  ) {
    this.id = id;
    this.groupId = groupId;
    this.name = name;
    this.surname = surname;
    this.address = address;
    this.title = title;
    this.salutation = salutation;
    this.fullName = fullName;
    this.type = type;
    this.tagIds = tagIds;
    this.notes = notes;
    this.isArchived = isArchived;
    this.attributes = attributes;
    this.isKeyloop = isKeyloop;
    this.isBlocked = isBlocked;
  }
}
